import React, { useMemo } from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { useModalContext } from '../../../../context/ModalContext';
import { getSortedMembers } from '../../../../helpers/members';
import getFullname from '../../../../helpers/get-fullname';
import getMemberNickname from '../../../../helpers/get-member-nickname';
import MemberPhoto from '../../MembersComponents/MemberPhoto';
import MemberDetailsModal from '../../MembersComponents/MemberDetailsModal';
import { CButton, CTags } from '../../../UI';

import './style.scss';

/**
 *
 * @param {array} members Array of members
 * @param {function} onMemberClick Callback on member click. Returns target member
 * @param {funciton} onMessageClick Callback on click button for ask a question. Returns target member
 * @returns {reactComponent}
 */

const MembersPageView = ({
    event,
    members = null,
    settings = null,
    isWidget = false,
    photoVisible = true,
    showTextToRight = false,
    showBigPhotos = false,
    showPhotoCentered = false,
    onMemberClick,
    onMessageClick,
}) => {

    if (!members) {
        return null;
    }

    const $locale = useLocaleContext();
    const {renderModal} = useModalContext();

    const visibleMembers = useMemo(() => {
        if (event.moduleEpisode.sortMembers) {
            return getSortedMembers(members, $locale, 'lastname', 'en')
        }

        return members;
    }, [members]);

    function onMemberClick(member) {
        renderModal(MemberDetailsModal, {event, lockPageScroll: false, member, isWidget, settings});
    }

    function applySettings(key, condition = true) {
        if (!settings && condition) {
            return true;
        }

        return !!settings && !!settings?.[key];
    }

    return (
        <div className={`members-page-view ${showBigPhotos? 'members-page-view--lg-photo' : ''} ${showPhotoCentered ? 'members-page-view--center' : ''}`}>
            {
                visibleMembers.map((member, index) => (
                    <div
                        key={index}
                        className={`members-page-view-details ${!!showTextToRight ? 'members-page-view-details--horizontal' : ''}`}
                    >
                        {
                            photoVisible &&
                            <div className="members-page-view-details__photo">
                                <MemberPhoto
                                    photo={member.profileUrl || undefined}
                                    initials={getMemberNickname(member, $locale)}
                                    size="auto"
                                    customSize={!!showTextToRight ? 84 : 0}
                                    onClick={() => onMemberClick(member)}
                                />
                            </div>
                        }
                        <div className="members-page-view-details__info">
                            {
                                applySettings('showRoles') &&
                                <CTags
                                    tags={member.roles}
                                    size="small"
                                />
                            }
                            {
                                applySettings('showFullname') &&
                                <a
                                    href=""
                                    className="members-page-view-details__info-name"
                                    style={{fontWeight: applySettings('showFullnameBold') ? 'bold' : 'normal'}}
                                    onClick={(e) => {e.preventDefault(); onMemberClick(member);}}
                                >
                                    {getFullname(member, $locale)}
                                </a>
                            }
                            {
                                applySettings('showOrganization') &&
                                <div>
                                    <p
                                        className="members-page-view-details__info-text members-page-view-details__info-text--company"
                                        style={{fontWeight: applySettings('showOrganizationBold') ? 'bold' : 'normal'}}
                                    >
                                        {$locale.getProperty(member, 'company')}
                                    </p>
                                </div>
                            }
                            {
                                applySettings('showRegalia') &&
                                <p
                                    className="members-page-view-details__info-text"
                                    style={{fontWeight: applySettings('showRegaliaBold', false) ? 'bold' : ''}}
                                >
                                    {$locale.getProperty(member, 'regalia')}
                                </p>
                            }
                            {/* Скрыто т.к. пока не используется */}
                            {/* <CButton
                                blank
                                icon="message"
                                label={$locale.get('label.question.ask')}
                                className="members-page-view-details__info-question"
                                onClick={() => onMessageClick(member)}
                            /> */}
                        </div>
                    </div>
                ))
            }
        </div>
    )
};

export default MembersPageView;
